import api from '../api/axiosConfig';
export async function getHomeData({ signal, force = false } = {}) {
  const early = window.__JLASTORE_HOME__;
  if (!force && early?.promise && Date.now() - early.startedAt < 30000) {
    const body = await early.promise;
    if (body?.status === 'success') return { data: body };
  }
  return api.get('/store/home', { signal, cache: force ? false : undefined, storefrontEncryption: false });
}
